import { useEffect, useState  } from "react";
import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
    NUMERIC_FIELD_TYPE,
    DATE_FIELD_TYPE,
    AUTOCOMPLETE_FIELD_TYPE,
    PROUDCT_STATUS_AVAILABLE_ID
} from "../../../helpers/constants";

export const PROPOSAL_TABLE_NAME = "status_proposal_table";

import { useProposalFilteringData } from "../../../services/productsService";


export const useStatusProposalFormTableFieldsConfig = () => {
    const { t } = useTranslation();
    const { data: filteringData } = useProposalFilteringData()

    return [
        {
            name: "product_number",
            getValueCallback: (rowData) => rowData.product_number,
            label: t("products.columns.product_number"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_type",
            getValueCallback: (rowData) => rowData.product_type,
            label: t("products.columns.product_type"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "product_status",
            getValueCallback: (rowData) => rowData.product_status,
            label: t("products.columns.product_status"),
            dataType: TEXT_FIELD_TYPE,
            editable: false,
        },
        {
            name: "proposal_status",
            getValueCallback: (rowData) => rowData.proposal_status,
            label: t("products.columns.proposal_status"),
            editable: true,
            dataType: AUTOCOMPLETE_FIELD_TYPE,
            getFilterFieldConfigCallback: () => ({
                optionLabelKey: "status_name",
                options: filteringData?.product_status?.filter(status=>status.id == PROUDCT_STATUS_AVAILABLE_ID),
                multiple: false,
                isObjectOption: true,
                disableClearable: true
            }),
        }
    ];
};
